import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { SPECIAL_OFFER_PREVIEW, SPECIAL_OFFER_STATUS } from 'src/app/extensions/constants/commonConstants';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-special-offer-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  standalone: false,
})
export class PreviewComponent implements OnInit {
  SPECIAL_OFFER_PREVIEW = SPECIAL_OFFER_PREVIEW;
  selectedTab: string = SPECIAL_OFFER_PREVIEW.INFO;
  specialOfferId: string;
  status: string;
  specialOfferStatus = SPECIAL_OFFER_STATUS;
  canUnloadByPassForm: boolean = false;
  isFormDirty = false;

  constructor(
    private _location: Location,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.specialOfferId = this._activatedRoute.snapshot.params['specialOfferId'];
  }

  redirectListHandler() {
    this._location.back();
  }

  tabChangeHandler(selectedTab: string) {
    this.selectedTab = selectedTab;
  }

  formChangeHandler(event: boolean) {
    this.isFormDirty = event;
  }

  unloadByPassForm(event: boolean) {
    this.canUnloadByPassForm = event;
  }

  setSpecialOfferStatus(event: string) {
    this.status = event;
  }
}
